import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import sendanemail from "src/Assets/images/sendanemail.png";
import { Modal } from "react-bootstrap";
import styles from "src/Assets/css/home/post.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

import PostMessageValidation from "src/Modules/Reusuablecomponents/PostMessageValidation";
import SimpleDialogDemo from "src/Modules/Reusuablecomponents/CustomizedDialogs";
import ReusuableSendaMailModal from "src/Modules/Reusuablecomponents/ReusuableSendaMailModal";
import ReusuableReportDialogmodal from "src/Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import follow from "src/Assets/images/follow.svg";
import unfollow from "src/Assets/images/unfollow.svg";
import Edit from "src/Assets/images/edit.svg";
import Delete from "src/Assets/images/Delete.svg";
import Location from "src/Assets/images/locationpin.png";
import messageImg from "src/Assets/images/noofsays.svg";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import replyIcon from "src/Assets/images/message new icon.png";
import answerIcon from "src/Assets/images/answerIcon.png";
import API from "../../../../network";
import ReportModal from "../../../../Modules/Reusuablecomponents/reportModal";
import PopupDisplayModal from "../../../Reusuablecomponents/PopopDisplayModal";
import { PiDotsThreeBold } from "react-icons/pi";

import ChildSay from "../ChildSay";
import AvatarBadge from "src/Components/AvatarBadge";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import ReusuableDeleteDialogmodal from "src/Modules/Reusuablecomponents/ReusuableDeleteModal";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import MapDialog from "src/pages/HomePage/components/LocationAddress";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";

const PopupComponent = ({
  open,
  onClose,
  popupData,
  // setPopupData,
  followunfollow,
  postId,
  deletePopupMessage,
  filtertype,
  postType,
}) => {
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [postData, setPostData] = useState({});
  const [popupChildSayId, setPopupChildSayId] = useState(null);
  const [editID, setEditID] = useState(null);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});
  const [textValue, setTextValue] = useState("");
  const [textCount, setTextCount] = useState(0);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });

  const notificationStatusArray = selectedPost?.mainuserdata?.notificationStatus
    ? selectedPost.mainuserdata.notificationStatus.split(",")
    : [];

  const mailRestrictionStatus = notificationStatusArray[8] || "";
  const isLightColor = mailRestrictionStatus === "N";

  useEffect(() => {
    setPostData(popupData);
  }, [popupData]);

  useEffect(() => {
    let msg = textValue || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const count = msg.length;
    setTextCount(count);
  }, [textValue]);

  const onUpdateMessage = (id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    setPostData((prev) => {
      const childQ = prev?.childQ || [];
      const updatedChildQ = childQ.map((item) => {
        if (item.id === id) {
          const { newSelectedLocation, ...cleanItem } = item;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (item?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            locName: locationName || "",
            msgLat: locationName ? (lat || item.msgLat || "") : "",
            msgLng: locationName ? (lng || item.msgLng || "") : "",
            docName: attachment?.name || item.docName || "",
            docLocation: tempUrl || item.docLocation || "",
            docTagged: attachment ? 1 : item.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        } else {
          return { ...item };
        }
      });
      return { ...prev, childQ: updatedChildQ };
    });
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        setPostData((prev) => {
          const childQ = prev?.childQ || [];

          const updatedChildQ = childQ.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                docName: null,
                docLocation: null,
                docTagged: 0,
              };
            }
            return item; // keep original reference
          });

          return {
            ...prev,
            childQ: updatedChildQ,
          };
        });

        setIsAttacmentDeleted(response?.data?.status);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  const onSendMail = async (id) => {
    if (textValue?.trim()) {
      await API.postMail(id, textValue);
      setEmailPopupOpen(false);
    }
  };

  const onClickSendEmailOption = (selectedPost) => {
    setEmailPopupOpen(true);
    setSelectedPost(selectedPost);
  };

  const setUpdatedText = (e) => {
    const newValue = e.target.value;
    setTextValue(newValue);
  };

  const updateMessage = (id, message, locationName, attachment, lat, lng) => {
    onUpdateMessage(id, message, locationName, attachment, lat, lng);
    setEditID(null);
  };

  const cancelEdit = () => {
    removeNewSelectedLocationKey();
    setEditID(null);
  };

  const truncateLocationName = (locationName, newSelectedLocation) => {
    const maxLength = 60; // set your desired max length
    const nameToDisplay = newSelectedLocation || locationName;
    if (nameToDisplay.length > maxLength) {
      return nameToDisplay.substring(0, maxLength) + "...";
    } else {
      return nameToDisplay;
    }
  };

  const updateSayCount = (id, operator) => {
    const childQ = postData?.childQ || [];
    const updatedChildQ = childQ.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          sayCount:
            operator === "increment" ? item.sayCount + 1 : item.sayCount - 1,
        };
      } else {
        return { ...item };
      }
    });
    setPostData({ ...popupData, childQ: updatedChildQ });
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    setPostData((prev) => {
      const childQ = prev?.childQ || [];
      const updatedChildQ = childQ.map((item) => {
        if (item.id === editID) {
          return {
            ...item,
            newSelectedLocation: newSelectedLoc, // Added a temporary key-value pair
          };
        } else {
          return { ...item };
        }
      });
      return { ...prev, childQ: updatedChildQ };
    });
  };

  const removeNewSelectedLocationKey = () => {
    setPostData((prev) => {
      const childQ = prev?.childQ || [];
      const updatedChildQ = childQ.map((item) => {
        if (item.id === editID) {
          const { newSelectedLocation, ...cleanItem } = item;
          return cleanItem;
        }
        return item;
      });
      return { ...prev, childQ: updatedChildQ };
    });
  };
  console.log(`postData.childQ:`, postData.childQ);

  const sendBtnEnabled = textCount > 0 && textCount <= 280;

  return (
    <>
      <Popup
        modal
        key={postId}
        open={open}
        contentStyle={{
          borderRadius: "10px",
          padding: "20px",
          zIndex: 1601,
          position: "relative",
        }}
        closeOnDocumentClick={false}
        overlayStyle={{ zIndex: 1600 }}
        closeOnEscape={false}
      >
        <div>
          {postData && Array.isArray(postData?.childQ) ? (
            postData.childQ.map((item, index) => (
              <div key={index}>
                <div className={activityStyle.askTagPopupNameTimeMainContainer}>
                  <div className={feedstyles.avatarContainer}>
                    <AvatarBadge
                      src={`${profileImagePath}${item?.uimage}`}
                      alt={item?.displayName}
                      isPrimaryModerator={
                        item?.mainuserdata?.isModerator == 1 &&
                        item?.mainuserdata?.isPM == 1
                      }
                      isModerator={
                        item?.mainuserdata?.isModerator == 1 &&
                        item?.mainuserdata?.isPM == 0
                      }
                    />
                    <ProfileHoverCard result={item} />
                  </div>
                  <div className={activityStyle.askTagPopupNameTimeContainer}>
                    <p>{item.displayName}</p>
                    <span>
                      {item.Message_Time} in {item.tenant_name}{" "}
                      {(item.locName || item.newSelectedLocation) && (
                        <>
                          <img
                            src={Location}
                            style={{
                              margin: "-3px 4px 0 4px",
                              height: "12px",
                              cursor: "pointer",
                            }}
                            alt=""
                            onClick={() =>
                              handleClickOpen(
                                item.locName,
                                item.msgLat,
                                item.msgLng,
                              )
                            }
                          />
                          <span
                            onClick={() =>
                              handleClickOpen(
                                item.locName,
                                item.msgLat,
                                item.msgLng,
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {truncateLocationName(
                              item.locName,
                              item.newSelectedLocation,
                            )}
                          </span>
                        </>
                      )}
                    </span>
                  </div>

                  <div className={activityStyle.askTagPopupDropdownButton}>
                    <IconButton
                      onClick={onClose}
                      style={{
                        padding: 0,
                        width: 30,
                        height: 30,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                    >
                      <IoIosCloseCircleOutline fontSize={25} />
                    </IconButton>
                    <Menu portal={true} viewScroll="close" position="anchor" reposition="auto"
                      menuButton={
                        <IconButton
                          style={{
                            padding: 0,
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            outline: "none",
                          }}
                        >
                          {/* <MdKeyboardArrowDown fontSize={25} /> */}
                          <PiDotsThreeBold
                            fontSize={25}
                            color="rgba(0, 0, 0, 0.7)"
                          />
                        </IconButton>
                      }
                      transition
                      direction="bottom"
                      arrow
                      menuStyle={{
                        backgroundColor: "white",
                        borderRadius: 20,
                      }}
                      align="end"
                    >
                      {(item.Keyword_ID === "H" ||
                        item.Keyword_ID === "hashTAG" ||
                        item.message_type === "X" ||
                        item.message_type === "H" ||
                        item.Keyword_ID === "#TAG") && (
                        <MenuItem>
                          <ReusuableTagActionModal
                            type="download"
                            tagId={item?.id}
                            tagName={item?.Message}
                            tagData={item}
                          />
                        </MenuItem>
                      )}
                      {(item.Keyword_ID === "H" ||
                        item.Keyword_ID === "hashTAG" ||
                        item.message_type === "X" ||
                        item.message_type === "H" ||
                        item.Keyword_ID === "#TAG") && (
                        <MenuItem>
                          <ReusuableTagActionModal
                            type="rating"
                            tagId={item?.id}
                            tagName={item?.Message}
                            tagData={item}
                          />
                        </MenuItem>
                      )}
                      {item.User_ID !== userDetails.userData.User_ID ? (
                        <>
                          {item.moderatorStatus === "1" ? (
                            <>
                              <MenuItem>
                                <ReusuableDeleteDialogmodal
                                  label={"Delete Post"}
                                  type={item.Keyword_ID || "hashTAG"}
                                  id={item.id}
                                  deleteMessage={() =>
                                    deletePopupMessage &&
                                    deletePopupMessage(item.id)
                                  }
                                />
                              </MenuItem>
                              <MenuItem onClick={() => onClickSendEmailOption(item)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={sendanemail} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Send email to {item.displayName}</span>
        </div>
      </MenuItem>
                            </>
                          ) : (
                            <>
                              <MenuItem>
                                <ReportModal id={item.id} param={"AskorSay"} />
                              </MenuItem>
                              <MenuItem onClick={() => onClickSendEmailOption(item)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={sendanemail} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Send email to {item.displayName}</span>
        </div>
      </MenuItem>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <MenuItem onClick={() => setEditID(item.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={Edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit Post</span>
        </div>
      </MenuItem>

                          <MenuItem>
                            <ReusuableDeleteDialogmodal
                              label={"Delete Post"}
                              type={item.Keyword_ID || "hashTAG"}
                              id={item.id}
                              deleteMessage={() =>
                                deletePopupMessage &&
                                deletePopupMessage(item.id)
                              }
                            />
                          </MenuItem>
                        </>
                      )}
                    </Menu>
                  </div>
                </div>
                <div className={activityStyle.activityPostDescriptionContainer}>
                  {editID === item?.id ? (
                    <PostMessageValidation
                      id={item.id}
                      Message={item.Message}
                      messageType={"feedTextArea"}
                      filtertype={filtertype}
                      post={item}
                      onCloseEdit={cancelEdit}
                      latitude={item.msgLat}
                      longitude={item.msgLng}
                      locationAddress={item.locName}
                      updateNewSelectedLocation={updateNewSelectedLocation}
                      removeNewSelectedLocationKey={removeNewSelectedLocationKey}
                      onMessagedUpdated={updateMessage}
                      onDeleteAttachment={handleDeleteAttachementDoc}
                      docName={item?.docName}
                      isAttacmentDeleted={isAttacmentDeleted}
                      setIsAttacmentDeleted={setIsAttacmentDeleted}
                    />
                  ) : (
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "baseline", // aligns with text bottom
                        flexWrap: "wrap",
                        gap: "5px", // small gap between text and file name
                      }}
                    >
                      <Typography>
                        <TextWithUrlsAndHashTags
                          Message={item?.Message}
                          text={item?.msg}
                          hashtags={item?.tag}
                          urls={item?.url}
                          // onHashtagClick={onHashTagClick}
                        />
                      </Typography>
                      <PostAttachmentViewer
                        docLocation={item?.docLocation}
                        docTagged={item?.docTagged}
                        docName={item?.docName}
                        messageID={item?.id}
                        activeTooltip={activeTooltip}
                        setActiveTooltip={setActiveTooltip}
                      />
                    </div>
                  )}
                </div>
                {editID !== item?.id && (
                  <>
                    <p className={activityStyle.askTagPopupFollowers}>
                      <PopupDisplayModal
                        followCount={item?.followCount}
                        followData={item?.follweduserprofile}
                        id={item.id}
                        hashTagType={item?.hashTagType}
                      />
                    </p>
                    <hr className={activityStyle.askTagPopupHorizontalLine} />
                    <PostActions
                      item={item}
                      popupChildSayId={popupChildSayId}
                      setPopupChildSayId={setPopupChildSayId}
                      followunfollow={followunfollow}
                    />
                    {popupChildSayId === item.id && (
                      <div style={{ height: "60vh", overflowY: "scroll" }}>
                        <ChildSay
                          key={popupChildSayId}
                          id={item?.id}
                          item={item}
                          updateSayCount={updateSayCount}
                          postType={"Answer"}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            ))
          ) : (
            <p>No data</p>
          )}
        </div>
      </Popup>
      <Modal
        show={emailPopupOpen}
        style={{ backgroundColor: "#00000060", zIndex: 4000 }}
        centered
        contentClassName="custom-modal-content"
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#fff" }}
          onClick={() => setEmailPopupOpen(false)}
        >
          <Modal.Title>Send email</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {mailRestrictionStatus === "N" ? (
            <p>{`${selectedPost?.displayName} is not accepting emails`}</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <textarea
                rows="6"
                cols="44"
                className={styles.sendamailtextarea}
                id={`textInputMail${selectedPost?.id}`}
                // onInput={() => myFunction(props.id)}
                value={textValue}
                onChange={(e) => setUpdatedText(e)}
                placeholder={`What would you like to say to ${selectedPost?.displayName}`}
                // maxLength={280}
              />
              <label style={{ textAlign: "end", width: "100%" }}>
                <label style={{ color: textCount > 280 ? "red" : "black" }}>
                  {textCount}
                </label>
                /280
              </label>
              <button
                type="button"
                id={`buttonforEdit${selectedPost?.id}`}
                className={styles.sendaMail}
                style={{ left: 0, opacity: sendBtnEnabled ? 1 : 0.6 }}
                onClick={() => onSendMail(selectedPost?.id)}
                disabled={!sendBtnEnabled}
              >
                Send
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
    </>
  );
};

const PostActions = ({
  item,
  popupChildSayId,
  setPopupChildSayId,
  followunfollow,
}) => {
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);

  const followunfollowCallback = (id, actionString, elementId) => {
    followunfollow(id, actionString, elementId);
  };

  return (
    <>
      <div className="PostActions--Following">
        <div
          style={{
            cursor: "pointer",
            marginTop: "0px",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() =>
            setPopupChildSayId(item.id === popupChildSayId ? null : item.id)
          }
        >
          <img
            src={item.message_type === "A" ? answerIcon : replyIcon}
            className={
              item.message_type === "A"
                ? activityStyle.activityAnswerIcon
                : activityStyle.activityReplyIcon
            }
            style={{ marginBottom: "-2px" }}
            alt="ChildSay"
          />
          &nbsp;
          {item.sayCount > 0 && item.sayCount}&nbsp;
          {(() => {
            const isAnswer = item.message_type === "A";
            const singular = isAnswer ? "Answer" : "Reply";
            const plural = isAnswer ? "Answers" : "Replies";
            return item.sayCount === 1 || item.sayCount === 0
              ? singular
              : plural;
          })()}
        </div>
        <div style={{ cursor: "pointer", marginTop: "3px" }}>
          {item.followStatus === "Active" || item.followStatus === "Y" ? (
            <div
              id={`1${item.id}`}
              onClick={(e) => {
                e.stopPropagation();
                // followunfollow(item.id, "isFollow=0", "1");
                setShowUnfollowAlert(item.id);
              }}
            >
              <img src={unfollow} alt="UnFolow" />
              <span>&nbsp;Unfollow</span>
            </div>
          ) : (
            <div
              id={`0${item.id}`}
              onClick={(e) => {
                e.stopPropagation();
                followunfollow(item.id, "isFollow=1", "0");
              }}
            >
              <img src={follow} alt="Folow" />
              <span>&nbsp;Follow</span>
            </div>
          )}
        </div>
      </div>
      {showUnfollowAlert === item.id && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)} // Close alert
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollowCallback(item.id, "isFollow=0", "1"); // Call actual function
            setShowUnfollowAlert(null); // Close alert
          }}
        />
      )}
    </>
  );
};

export default PopupComponent;
